import { useQuery } from "@apollo/client/react";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router";

import { constantsData } from "@/data";
import { getUsersListQuery } from "@/graph";
import { openAlert } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useUsersList = () => {
    const [params] = useSearchParams();

    const pageParam = parseInt(params.get("page")) || 1;

    const limitParam = parseInt(params.get("limit")) || 25;

    const [page, setPage] = useState(pageParam);

    const [limit, setLimit] = useState(limitParam);

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const { isAuthenticated } = useAuth0();

    const { data, error, loading } = useQuery(getUsersListQuery, {
        fetchPolicy: "cache-first",
        skip: !isAuthenticated,
        variables: {
            limit,
            page: page - 1,
        },
    });

    useEffect(
        () => {
            if (error?.message === constantsData.failedToFetch && !loading) {
                displayErrorHandler(t("messages.networkFailure"), dispatch, openAlert);
            }
        },
        [error, data], // eslint-disable-line
    );

    return {
        count: data?.listUsers?.meta?.nodeCount,
        data: data?.listUsers?.posts,
        error,
        limit,
        loading,
        page: data?.listUsers?.meta?.currentPage,
        setLimit,
        setPage,
    };
};

export default useUsersList;
